import React from "react";
import { connect } from "react-redux";
import { Modal, Select } from "antd";
import useModalLocation from "./useModalLocation";
import { _set_store } from "../../../store/actions/login_actions";
import { ReactComponent as BottomArrow } from "../../../assets/svg/bottom-arrow.svg";
import Button from "../ui/Button";

const { Option } = Select;
const ModalLocation = (props) => {
  const {
    redux_set_store,
    categoryFunction,
    sliderFunction,
    toInvisible,
    visible,
  } = props;

  const [
    city_list,
    country_list,
    selected_city,
    selected_country,
    select_country,
    select_city,
    set_store,
  ] = useModalLocation(
    redux_set_store,
    categoryFunction,
    sliderFunction,
    toInvisible
  );

  return (
    <Modal
      className="change-store-location"
      closable={false}
      open={visible}
      footer={false}
    >
      <div className="change-store-location-body">
        <p
          className="font-14 m-3"
          style={{ color: "var(--hig-color-black-3)" }}
        >
          Select your preffered Province / City
        </p>
        <Select
          className="change-store-select"
          placeholder="Province"
          popupClassName="change-store-select-dropdown"
          suffixIcon={<BottomArrow width={10} height={10} />}
          value={selected_country}
          onChange={(value) => select_country(value)}
          placement="bottomRight"
        >
          {country_list.map((country, pdx) => {
            return (
              <Option key={pdx} value={country.id}>
                {country.name}
              </Option>
            );
          })}
        </Select>

        {selected_country !== null && (
          <React.Fragment>
            <Select
              className="change-store-select"
              placeholder="City"
              popupClassName="change-store-select-dropdown"
              suffixIcon={<BottomArrow width={10} height={10} />}
              value={selected_city}
              onChange={(value) => select_city(value)}
              placement="bottomRight"
            >
              {city_list.map((city, cdx) => {
                return (
                  <Option key={cdx} value={city.id}>
                    {city.name}
                  </Option>
                );
              })}
            </Select>
          </React.Fragment>
        )}
      </div>
      <div className="change-store-location-button-container">
        <Button
          style_width={"100%"}
          className={`change-store-location-button ${
            !selected_country || !selected_city ? "custom-disabled" : ""
          }`}
          onClick={(e) => {
            if (!selected_country || !selected_city) {
              e.preventDefault();
            } else {
              set_store();
            }
          }}
        >
          Enter
        </Button>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  Login: state.Login,
});

const mapDispatchToProps = (dispatch) => {
  return {
    redux_set_store: (
      province_id,
      city_id,
      store_id,
      province_name,
      city_name
    ) => {
      dispatch(
        _set_store(province_id, city_id, store_id, province_name, city_name)
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalLocation);
